import { Text } from '@mantine/core';

import { useGetInputActionLabel } from 'app/modules/wallforming/components/input-binding/hooks/useGetInputActionLabel';

import type { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';

interface ActionShortcutHintProps {
    actionId: InputActionId;
    className?: string;
}

/** Right-aligned menu hint showing the action's current bindings from the active profile. */
export const ActionShortcutHint = ({ actionId, className = '' }: ActionShortcutHintProps) => {
    const label = useGetInputActionLabel(actionId);
    return <Text className={`action-menu-entry-decoration-text text-right text-[13px] ${className}`}>{label}</Text>;
};
